export default "__VITE_ASSET__Dro9HQdZ__"